<template>
    <list-base-template
        :items='items'
        :event='event'
        :create='true'
        :errors='this.errors'
        v-on:create='openCreate()' 
        v-on:paginate='getResults()'>

        <template v-slot:header>
            <h2 class="h4 p-2 m-0">{{ $t("translations.tags")}}</h2>
        </template>   

        <template v-slot:filter>
            <inline-filter v-if='filter_type == "inline"'
                v-on:filterUpdated='getResults(1)' 
                :expanded='true' 
                :key='event' 
                ref="listFilter" 
                :modalid='modalid'></inline-filter>
            <list-filter v-else-if='filter_type == "popup"'
                v-on:apply='getResults(1)' 
                :expanded='true' 
                :key='event' 
                ref="listFilter" 
                :modalid='modalid'></list-filter>
        </template>

        <template v-slot:list>
            <ul :class='"list list-" + model'>

                <template v-for="item in items.data">
                    <router-link tag='li' :to='(subroute ? "/" + event + "-list" : "") + "/" + event + "-show/" + item.id' :key='item.id' :class='"list-" + event + "_item"'>
                        <h2 class="h6"><strong>{{item.name}}</strong></h2>
                        <div class='search-lozenge-thin badge badge-primary badge-pill' :style="{'background-color': item.colour}">
                            <i v-if='item.icon' :class='"pr-1 fa fa-lg fa-" + item.icon'></i> {{ item.name }}
                        </div>
                    </router-link>    
                </template>
            </ul>
        </template>

        <template v-slot:selectedcontent>
            <router-view 
                v-on:delete='getResults()' 
                v-on:change='getResults()' 
                ref='content2' 
                name='content2' 
                :key="$route.fullPath">
            </router-view>
        </template>
    </list-base-template>
</template>

<script>
	export default {
        extends: app.base.listBase,
		props: [
		],
		data: function() {
			return {
                modalid: "tag-filter-modal",
                event: "tag",
                model: "tag",
                title: "tag_entries",
                path: 'tag',
                route: this.$root.apiBase + '/tags',
                // Should be enabled for
                    // "usergroup"
                    // "feedback"
                force_na_provider_id: false,
                search_on_open: true,
                filter_type: "inline",
            };
        },
        watch: {
            
        },
		methods : {
		}
    }
</script>
